import { AnyAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { all, getContext, put, takeEvery } from 'redux-saga/effects';
import { MailsService } from '../service';
import {
	addMail,
	addMailFailure,
	addMailSuccess,
	deleteMail,
	deleteMailFailure,
	deleteMailSuccess,
	getAllMails,
	getAllMailsFailure,
	getAllMailsSuccess,
	getMailsTemplates,
	getMailsTemplatesFailure,
	getMailsTemplatesSuccess,
	getMailToUpdate,
	getMailToUpdateFailure,
	getMailToUpdateSuccess,
	updateMail,
	updateMailFailure,
	updateMailSuccess,
} from './slice';

function* getAllMailsListHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const mailService = new MailsService(globalApplicationContext);
		const data = yield mailService.getAllMails(action.payload.page);
		yield put(getAllMailsSuccess(data));
	} catch (e) {
		yield put(getAllMailsFailure(e));
		console.error(e);
	}
}

function* deleteMailHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const mailService = new MailsService(globalApplicationContext);
		yield mailService.deleteMail(action.payload.mailId);
		yield put(deleteMailSuccess({}));
		toast('Mail deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteMailFailure(e));
		console.error(e);
	}
}

function* addMailHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const mailService = new MailsService(globalApplicationContext);
		yield mailService.addMail(action.payload);
		yield put(addMailSuccess({}));
		toast('Mail created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(addMailFailure({}));
	}
}

function* getMailToUpdateHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const mailService = new MailsService(globalApplicationContext);
		const data = yield mailService.getMailById(action.payload.mailId);
		yield put(getMailToUpdateSuccess(data));
	} catch (e) {
		yield put(getMailToUpdateFailure({}));
	}
}

function* updateMailHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const mailService = new MailsService(globalApplicationContext);
		yield mailService.updateMail(action.payload);
		yield put(updateMailSuccess({}));
		toast('Mail updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateMailFailure({}));
	}
}

function* getMailTemplatesHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const mailService = new MailsService(globalApplicationContext);
		const data = yield mailService.getMailsTemplates(
			action.payload.nextPageUrl,
		);
		yield put(getMailsTemplatesSuccess(data));
	} catch (e) {
		yield put(getMailsTemplatesFailure({}));
	}
}

export function* mailsSaga(): Generator<any, any, any> {
	yield all([
		takeEvery(getAllMails, getAllMailsListHandler),
		takeEvery(deleteMail, deleteMailHandler),
		takeEvery(addMail, addMailHandler),
		takeEvery(getMailToUpdate, getMailToUpdateHandler),
		takeEvery(updateMail, updateMailHandler),

		takeEvery(getMailsTemplates, getMailTemplatesHandler),
	]);
}
